import Card from "../Card/Card";
import { IconComponentType } from "../Icon/Icon";
import Switch from "../Switch/Switch";
import styles from "./SwitchCard.module.scss";

function SwitchCard({
  IconComponent,
  className,
  checked,
  title,
  subtitle,
  onToggle,
}: {
  IconComponent: IconComponentType;
  className?: string;
  checked: boolean;
  title: string;
  subtitle?: string;
  onToggle: () => void;
}) {
  return (
    <Card className={className}>
      <label className={styles.label}>
        <IconComponent size="large" className={styles.icon} />
        <div className={styles.text}>
          <p className={styles.title}>{title}</p>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        <Switch
          className={styles.switch}
          checked={checked}
          onCheckedChange={onToggle}
        />
      </label>
    </Card>
  );
}

export default SwitchCard;
